'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const ErrorMessages=require('../../../../../../../dist-es6/client/errorMessages');
const SocketResponse=require('../../../../../../../dist-es6/client/dtos/socketResponse');
const BaseControllerBackedDirective=require('../../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const delay=require('pulsar-utils/dist-es6/async/delay');let

AutoRefreshDirective=function(_BaseControllerBacked){_inherits(AutoRefreshDirective,_BaseControllerBacked);function AutoRefreshDirective(){_classCallCheck(this,AutoRefreshDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(AutoRefreshDirective,[{key:'templateUrl',get:function()
{return'/templates/features/emirates/emiratesDashboard/components/autoRefreshDirective/autoRefreshTemplate'}},{key:'objectBindings',get:function()

{return['switchedOn','refreshFunc','refreshRateSeconds']}},{key:'$inject',get:function()

{return['$scope','$interval']}},{key:'controller',get:function()

{return AutoRefreshController}}]);return AutoRefreshDirective}(BaseControllerBackedDirective);


const ControllerDefaults={
switchedOn:!1,
refreshFunc:function(){var ref=_asyncToGenerator(function*(){
});return function refreshFunc(){return ref.apply(this,arguments)}}()};let


AutoRefreshController=function(){
function AutoRefreshController($scope,$interval){var _this2=this;_classCallCheck(this,AutoRefreshController);
_.defaults(this,ControllerDefaults);

$scope.$on('$destroy',function(){
if(_this2._intervalCancellationToken){
$interval.cancel(_this2._intervalCancellationToken);
}
});

$scope.$watch('controller.switchedOn',function(oldVal,newVal){
if(_this2.switchedOn&&!_this2._intervalCancellationToken){
_this2._intervalCancellationToken=$interval(function(){return _this2._tryStartRefresh()},_this2.refreshRateSeconds*1000);
return;
}
if(!_this2.switchedOn&&_this2._intervalCancellationToken){
$interval.cancel(_this2._intervalCancellationToken);
_this2._intervalCancellationToken=void 0;
return;
}
});
}AutoRefreshController.prototype.

_tryStartRefresh=function(){var ref=_asyncToGenerator(function*(){
if(!this.switchedOn||this._inRefresh){
return;
}
try{
this._inRefresh=!0;
yield this.refreshFunc();
}finally{
this._inRefresh=!1;
}
});function _tryStartRefresh(){return ref.apply(this,arguments)}return _tryStartRefresh}();return AutoRefreshController}();


module.exports=AutoRefreshDirective;
//# sourceMappingURL=autoRefreshDirective.js.map
